module.exports = __webpack_public_path__ + "media/site_templates/www.hirelocalplumbers.com.au/images/review_1-abf533eb9ae3f014aa52111447a234fd.png";